export default {
  HIGHLIGHTED_HEADINGS: [],
};
